import React from 'react'
import {Link} from 'gatsby'
import styles from './CategoryList.module.css'

const CategoryList = props => {
  const {categories} = props
  console.log(categories)
  return (<div>
    <ul className={styles.categoryList}>{categories.map(
      category =>
        <li key={category._id} className={styles.categoryListItem}>
          <Link to={`/tema/${category.slug.current}`}>{category.title}</Link>
        </li>
    )}</ul>
  </div>)
}

export default CategoryList
